import HardwareSoftware from "../../components/ClassTwo/ComputerStudies/HardwareSoftware";
import InputOutputDevice from "../../components/ClassTwo/ComputerStudies/InputOutputDevice";
import KnowComputer from "../../components/ClassTwo/ComputerStudies/KnowComputer";
import MSWindow from "../../components/ClassTwo/ComputerStudies/MSWindow";
import PaintProgram from "../../components/ClassTwo/ComputerStudies/PaintProgram";
import PartsComputer from "../../components/ClassTwo/ComputerStudies/PartsComputer";
import TheMouse from "../../components/ClassTwo/ComputerStudies/TheMouse";
import UseOfComputer from "../../components/ClassTwo/ComputerStudies/UseOfComputer";
import UsingKeyboard from "../../components/ClassTwo/ComputerStudies/UsingKeyboard";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-two/computer-studies/know-your-computer", title: "Know Your Computer", component: KnowComputer },
    { url: "/class-two/computer-studies/parts-of-computer", title: "Parts of Computer", component: PartsComputer },
    { url: "/class-two/computer-studies/hardware-and-software", title: "Hardware and Software", component: HardwareSoftware },
    { url: "/class-two/computer-studies/input-and-output-devices", title: "Input and Output Devices", component: InputOutputDevice },
    { url: "/class-two/computer-studies/using-a-keyword", title: "Using a Keyboard", component: UsingKeyboard },
    { url: "/class-two/computer-studies/mouse", title: "Mouse", component: TheMouse },
    { url: "/class-two/computer-studies/uses-of-computer", title: "Uses of Computer", component: UseOfComputer },
    { url: "/class-two/computer-studies/ms-window", title: "MS window", component: MSWindow },
    { url: "/class-two/computer-studies/paint-program", title: "Paint Program", component: PaintProgram },
];


export default topics;